import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import "./App.css";
import Header from "./components/Header";
import LoginPage from "./components/Login";
import Home from "./components/Home";
import MoahAudit from "./components/MoahAudit/MoahAudit";
import CampaignAgent from "./components/CampaignAgent/CampaignAgent";
import ProtectedRoute from "./components/ProtectedRoute";
import Admin from "./components/Admin";
import FirstLogin from "./components/FirstLogin";
import NotFound from "./components/NotFound";

function App() {
  return (
    <div className="App">
      <Router>
        <Header />
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route path="/first-login" element={<FirstLogin />} />
          {/* Protected Home Route */}
          <Route
            path="/"
            element={
              <ProtectedRoute
                allowedRoles={["admin", "sales", "marketing", "moah"]}
              >
                <Home />
              </ProtectedRoute>
            }
          />

          {/* Protected MOAH route */}
          <Route
            path="/moah-audit"
            element={
              <ProtectedRoute allowedRoles={["admin", "moah", "sales"]}>
                <MoahAudit />
              </ProtectedRoute>
            }
          />

          {/* Protected CampaignAgent route */}
          <Route
            path="/campaign-agent"
            element={
              <ProtectedRoute allowedRoles={["admin", "marketing"]}>
                <CampaignAgent />
              </ProtectedRoute>
            }
          />

          {/* 🔐 Protected Admin - Add User Route */}
          <Route
            path="/admin"
            element={
              <ProtectedRoute allowedRoles={["admin"]}>
                <Admin />
              </ProtectedRoute>
            }
          />
          <Route path="/404" element={<NotFound />} />

          {/* Wildcard route redirects to /404 */}
          <Route path="*" element={<Navigate to="/404" replace />} />
        </Routes>
      </Router>
    </div>
  );
}

export default App;
